import React from 'react'
import Typography from '@/components/ui/Typography'
import { useRouteEntryPoint } from '@/hooks/useRouteEntryPoint'
import classes from './DeployButton.module.scss'
import { useGetRoute } from '@/lib/react-query'

export type FlowDeployInstructionsProps = { projectId: number; routeId: number }

const FlowDeployInstructions = ({ projectId, routeId }: FlowDeployInstructionsProps) => {
  const {
    data: { route },
  } = useGetRoute(projectId, routeId)
  const routeUrl = useRouteEntryPoint(projectId, routeId)

  return (
    <div className={classes.httpRoot}>
      <div className={'d-grid gap-1'}>
        <Typography>
          You can use this route in your workflow in Knots Flow. To do that, go to your workflow page in Knots flow and
          add Studio node.
        </Typography>
      </div>
    </div>
  )
}

export default FlowDeployInstructions
